// @flow
import * as React from 'react';

import type { NotifyAction } from '@gandi/notifications';
import type { TranslatorProps } from '@gandi/translate';
import { Button } from '@gandi/ui';

import { SubmissionError } from 'gandi.react-form';

import type { WithRouterProps } from '../../../../helpers/withRouter';
import CustomerForm from '../../components/Form';

import type { CreateCustomerAction } from '../../modules/customers';
import type { CustomerDataForm, UrlParams } from '../../types';

export type StateProps = {
  currentOrganizationId: string,
  isCreatingCustomer: boolean,
};

export type DispatchProps = {
  createCustomer: CreateCustomerAction<Promise<mixed>>,
  notifyDanger: NotifyAction,
  destroyForm: () => mixed,
};

export type OwnProps = {
  ...WithRouterProps<UrlParams>,
  translator: TranslatorProps,
};

type Props = {
  ...StateProps,
  ...DispatchProps,
  ...OwnProps,
};

export default class Presenter extends React.Component<
  Props,
  {
    destroyOnUnmount: boolean,
  },
> {
  state: {
    destroyOnUnmount: boolean,
  } = {
    destroyOnUnmount: true,
  };

  componentWillUnmount() {
    if (this.state.destroyOnUnmount) {
      this.props.destroyForm();
    }
  }

  handleSubmit: (data: CustomerDataForm) => Promise<void> = (
    data: CustomerDataForm,
  ) => {
    const { __ } = this.props.translator;

    this.setState({
      destroyOnUnmount: false,
    });

    return this.props
      .createCustomer(this.props.currentOrganizationId, data, { dryrun: true })
      .then(
        () => {
          const confirm = `/cart/${this.props.params.cartId}/configure/account-choice/confirm/customer`;
          this.props.navigate(confirm);
        },
        error => {
          this.setState({
            destroyOnUnmount: true,
          });
          throw new SubmissionError(error.errors);
        },
      )
      .catch(err => {
        if (err instanceof SubmissionError) {
          throw err;
        }

        this.props.notifyDanger(
          __('An unknown error occurred. Please try again later.'),
        );
      });
  };

  render(): React.Node {
    const {
      params,
      translator: { __ },
    } = this.props;

    const back = `/cart/${params.cartId}/configure/account-choice`;
    const buttons = [
      <Button to={back} grouped kind="outline" key="cancel">
        {__('Cancel')}
      </Button>,
      <Button
        // $FlowFixMe[prop-missing]
        form={CustomerForm.FORM_ID}
        grouped
        key="submit"
        disabled={this.props.isCreatingCustomer}
      >
        {__('Create')}
      </Button>,
    ];

    return (
      // $FlowFixMe[prop-missing] FIXME: destroyOnUnmount and forceUnregisterOnUnmount are not declared; are they really used?
      <CustomerForm
        buttons={buttons}
        onSubmit={this.handleSubmit}
        destroyOnUnmount={false}
        forceUnregisterOnUnmount
        isCreation
      />
    );
  }
}
